export default {
  //课中活动讨论
  talkInfo: {
    add: '',
    replyList:''
  },
  talkList: [],
}
